import { modelOptions, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";

const SCHEMA_KEY = "Gen4SensorInternalState" as const;

type Gen4DataID = number;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<Gen4SensorInternalState>>(...addSchemaKeyHook(SCHEMA_KEY))
export class Gen4SensorInternalState extends SchemaBase<Gen4SensorInternalState> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Number, required: false })
    dataID?: Gen4DataID;

    @prop({ type: () => Number, required: true })
    sensingPeriod!: number;

    /**
     * every nth data point that is sensed will be stored and uplinked. The rest should be
     * discarded and just used for checking thresholds and automation
     */
    @prop({ type: () => Number, required: true })
    recordingInterval!: number;

    /**
     * Will be zero if alarms are not in use.
     */
    @prop({ type: () => Number, required: true })
    rawUpperAlarmThreshold!: number;

    /**
     * Will be zero if alarms are not in use.
     */
    @prop({ type: () => Number, required: true })
    rawLowerAlarmThreshold!: number;

    static getters = {} as const satisfies Record<string, (self: Gen4SensorInternalState) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<Gen4SensorInternalState>) {
        super(properties);
        Object.assign(this, properties);
    }
}
